import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";

const PageSubTitle = ({ caption}) => {
  return (
    <>
      <Box mt={4} mb={4}>
        <Typography variant="h4" align="center" gutterBottom sx={{
          fontWeight: 700,
          color: "#1A3865",
          letterSpacing: "0.4px",
        }}>
          {caption}
        </Typography>
      </Box>
     
    </>
  );
};


PageSubTitle.propTypes = {
  caption: PropTypes.string.isRequired,
};

export default PageSubTitle;
